export default __webpack_public_path__ + "static/3-universal-f52b14cc23baa7f8990d919d7c42bbfe.png";